import React from 'react'
import { BrowserRouter, HashRouter, Routes, Route, Navigate } from 'react-router-dom'
import { ThemeProvider, CssBaseline } from '@mui/material'
import { SnackbarProvider } from 'notistack'
import theme from './theme'
import HomeLayout from './components/layout/HomeLayout'
import TablaNormas from './pages/TablaNormas'
import NuevaPublicacion from './pages/NuevaPublicacion'
import TipoNormaLegal from './pages/TipoNormaLegal'
import VozNormaLegal from './pages/VozNormaLegal'
import Uo from './pages/Uo'
import AfectacionNormaLegal from './pages/AfectacionNormaLegal'
import Oficina from './pages/Oficina'
import OficinaTipoNormaLegal from './pages/OficinaTipoNormaLegal'
import OficinaNotif from './pages/OficinaNotif'
import Logout from './pages/Logout'
import NotFound from './pages/NotFound'
import ProtectedRoute from './components/common/ProtectedRoute'

export default function App() {
  const runtimeHost = typeof window !== 'undefined' ? window.location.hostname : ''
  const routerMode = (import.meta.env.VITE_ROUTER_MODE || '').toLowerCase()
  const useHashRouter = routerMode === 'hash' || runtimeHost.endsWith('.amplifyapp.com')
  const RouterComponent = useHashRouter ? HashRouter : BrowserRouter

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SnackbarProvider
        maxSnack={4}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        autoHideDuration={4000}
      >
        <RouterComponent
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          <Routes>
            <Route path="/notfound" element={<NotFound />} />
            <Route path="/logout" element={<Logout />} />
            <Route path="/" element={<HomeLayout />}>
              <Route index element={<TablaNormas />} />
              <Route path="dashboard" element={<Navigate to="/normas" replace />} />
              <Route path="normas" element={<TablaNormas />} />
              <Route path="nueva" element={<ProtectedRoute><NuevaPublicacion /></ProtectedRoute>} />
              <Route path="tipo-norma-legal" element={<ProtectedRoute><TipoNormaLegal /></ProtectedRoute>} />
              <Route path="voz-norma-legal" element={<ProtectedRoute><VozNormaLegal /></ProtectedRoute>} />
              <Route path="uo" element={<ProtectedRoute><Uo /></ProtectedRoute>} />
              <Route path="afectacion-norma-legal" element={<ProtectedRoute><AfectacionNormaLegal /></ProtectedRoute>} />
              <Route path="oficina" element={<ProtectedRoute><Oficina /></ProtectedRoute>} />
              <Route path="oficina-tipo-norma-legal" element={<ProtectedRoute><OficinaTipoNormaLegal /></ProtectedRoute>} />
              <Route path="oficina-notif" element={<ProtectedRoute><OficinaNotif /></ProtectedRoute>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </RouterComponent>
      </SnackbarProvider>
    </ThemeProvider>
  )
}
